var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.30598 0.636765L7.46476 5.25585C7.65861 5.40124 7.7727 5.62941 7.7727 5.87173C7.7727 6.11404 7.65861 6.34222 7.46476 6.48761L1.30598 11.1067C1.07233 11.2819 0.759643 11.3099 0.498634 11.1788C0.237625 11.0478 0.0732483 10.7803 0.0742231 10.4882V1.25008C0.0751923 0.958943 0.240312 0.69326 0.500929 0.563494C0.761546 0.433729 1.07307 0.462082 1.30598 0.636765Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.95c82cd62c2c64a82b4005cf22a86b18.svg";
export { ForwardRef as ReactComponent };